import { Box, Flex, Text } from '@chakra-ui/react';
import { IPeerReviewFirstAssessment } from '@publishing-engine/domain/models';
import { IFetchOrganizationAndJournalsInfo } from 'src/api/queries';
import { DisplayField } from 'src/components/shared/DisplayField';
import BetterSuitedForAnotherJournal from '../Submission/ReviewTab/BetterSuitedForAnotherJournal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/pro-light-svg-icons';
import FileViewerButtonText from '../Submission/FileViewerButtonText';

const ForEditorReview = ({
  configs,
  reviewAssessment,
  organizationData,
  submissionContextId
}: {
  configs: any;
  reviewAssessment: IPeerReviewFirstAssessment;
  organizationData: IFetchOrganizationAndJournalsInfo;
  submissionContextId?: string;
}) => {
  return (
    <Flex direction="column" gap={4}>
      <Text textStyle="headingGroup">For Editors</Text>

      {reviewAssessment?.areaOfExpertise && (
        <DisplayField
          fieldName="areaOfExpertise"
          value={reviewAssessment.areaOfExpertise}
          config={configs}
        />
      )}

      {configs?.betterSuitedForAnotherJournal && (
        <BetterSuitedForAnotherJournal
          config={configs?.betterSuitedForAnotherJournal}
          betterSuitedForAnotherJournal={
            reviewAssessment?.betterSuitedForAnotherJournal || null
          }
          organizationData={organizationData}
        />
      )}

      {reviewAssessment?.feedbackForEditors && (
        <Box flexDirection="column">
          <Text marginBottom={2} textStyle="headingItem">
            Feedback for Editor
          </Text>
          <Text textStyle="textBody">
            {reviewAssessment?.feedbackForEditors}
          </Text>
        </Box>
      )}
      {reviewAssessment?.reviewerAttachmentsEditor?.length && (
        <Flex direction="column">
          <Text textStyle="headingItem">Attachments for Editors</Text>
          {reviewAssessment?.reviewerAttachmentsEditor?.map(attachment => (
            <Flex
              key={attachment.name}
              flexDirection="column"
              borderBottom="1px"
              padding={4}
              borderColor="neutralPrimaryBorder"
              gap={2}
            >
              <Flex
                flexDirection="row"
                justifyContent="space-between"
                width="100%"
              >
                <Flex gap={2} alignItems={'center'}>
                  <FontAwesomeIcon icon={faFile} size="lg" />
                  <Text textStyle="textBody">{attachment.name}</Text>
                </Flex>
                <FileViewerButtonText
                  file={attachment}
                  submissionContextId={submissionContextId}
                  textStyle="textBody"
                  flexShrink={0}
                >
                  View
                </FileViewerButtonText>
              </Flex>
            </Flex>
          ))}
        </Flex>
      )}
      {reviewAssessment?.conflictOfInterest && (
        <DisplayField
          fieldName="conflictOfInterest"
          value={reviewAssessment.conflictOfInterest}
          config={configs}
        />
      )}
      {reviewAssessment?.canArticleBeShortened && (
        <DisplayField
          fieldName="canArticleBeShortened"
          value={reviewAssessment.canArticleBeShortened}
          config={configs}
        />
      )}
      {reviewAssessment?.meritFurtherCoverageUponPublication && (
        <DisplayField
          fieldName="meritFurtherCoverageUponPublication"
          value={reviewAssessment.meritFurtherCoverageUponPublication}
          config={configs}
        />
      )}
    </Flex>
  );
};

export default ForEditorReview;
